import axiosInstance from '../../../Core/AxiosInstance/axiosInstance';
import CryptoJS from 'crypto-js';
/**
 *
 * @param data {email:string,password:string}
 * @description make api call to login
 * @returns promise of user info data
 */
export const userLogin = async (data: { email: string; password: string }): Promise<any> => {
  const res: any = await axiosInstance.post('/dashboard/login', data);
  console.log(res.data.data.user.role);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
console.log(secretKey);

const role = res.data.data.user.role.name;
const encryptedRole = CryptoJS.AES.encrypt(role, secretKey).toString();

localStorage.setItem('role', encryptedRole);
  return res.data.data;
};

export const forgotPassword = async (data: { email: string }): Promise<any> => {
  const res = await axiosInstance.post('/dashboard/forgot-password', data);
  return res.data.message;
};

export const resetPassword = async (data: { email: string; password: string; password_confirmation: string }, token: string): Promise<any> => {
  const res = await axiosInstance.post(`/dashboard/reset-password?token=${token}`, data);
  return res.data.data;
};
